import { useEffect, useState } from 'react';

/**
 * Hook utilitaire : true si la viewport est < breakpoint (par défaut 1024px = lg Tailwind).
 * Synchronisé avec matchMedia → réagit aux rotations / redimensionnements.
 */
export default function useIsMobile(breakpointPx = 1024) {
  const query = `(max-width: ${breakpointPx - 1}px)`;

  const getInitial = () => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  };

  const [isMobile, setIsMobile] = useState(getInitial);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    // addEventListener n'existe pas sur les vieux Safari
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return isMobile;
}
